/* Siicre'Art — Cocooning Premium interactions (vanilla, no dependency) */
(function () {
  if (window.__saCocoon) return; window.__saCocoon = true;
  var CFG = window.SA_CFG || {};
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var T = function (en, fr) { return FR ? fr : en; };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var THRESHOLD = (CFG.threshold || 149) * 100;

  function money(c) {
    var v = (c / 100).toFixed(2);
    return FR ? v.replace('.', ',') + ' $' : '$' + v;
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.sa-reveal:not(.is-in), .sa-hero__media:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e, i) { e.style.transitionDelay = (Math.min(i % 4, 3) * 80) + 'ms'; io.observe(e); });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'sa-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- Cart helpers ---------- */
  function getCart() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function shippable(cart) {
    return cart.items.reduce(function (s, i) { return s + (i.requires_shipping ? i.final_line_price : 0); }, 0);
  }
  function refreshThemeCart(cart) {
    // Expanse / Archetype events + generic fallbacks
    ['cart:build', 'cart:updated', 'cart:refresh', 'theme:cart:reload'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    });
    try { document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true })); } catch (e) {}
    var count = cart.item_count;
    document.querySelectorAll('[data-cart-count], .cart-link__bubble-num, .cart-count, cart-count').forEach(function (b) { b.textContent = count; });
  }
  function addItems(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return getCart(); })
      .then(function (cart) {
        refreshThemeCart(cart); updateShipBars(cart);
        var left = THRESHOLD - shippable(cart);
        toast('✓ ' + T('Added to cart', 'Ajouté au panier') + (left > 0 ? ' · ' + T('Only ', 'Plus que ') + money(left) + T(' to free shipping', ' pour la livraison gratuite') : ' · ' + T('Free shipping unlocked 🎉', 'Livraison gratuite débloquée 🎉')) + ' · <a href="' + ROOT + 'cart" style="color:inherit;text-decoration:underline">' + T('View cart', 'Voir le panier') + '</a>');
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); var o = btn.dataset.label || btn.textContent; btn.dataset.label = o; btn.textContent = T('Added ✓', 'Ajouté ✓'); setTimeout(function () { btn.textContent = o; btn.classList.remove('is-added'); }, 1800); }
        return cart;
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || T('Sorry, this could not be added.', 'Désolé, impossible d’ajouter ce produit.'));
      });
  }
  window.SA = { addItems: addItems, getCart: getCart, money: money };

  /* ---------- Free shipping progress (drawer + cart page) ---------- */
  function shipHTML(cart) {
    var v = shippable(cart);
    if (!v) return '';
    var T2 = 19900, bar = function (p) { return '<div class="sa-progress"><div class="sa-progress__bar"><div class="sa-progress__fill" style="width:' + p + '%"></div></div></div>'; };
    if (v >= T2) return '<div class="sa-ship sa-ship--done" data-sa-ship>🎉 ' + T('FREE shipping anywhere in Canada!', 'Livraison GRATUITE partout au Canada !') + '</div>';
    if (v >= THRESHOLD) return '<div class="sa-ship sa-ship--done" data-sa-ship>🎉 ' + T('FREE shipping unlocked in Québec &amp; Ontario', 'Livraison GRATUITE débloquée au Québec et en Ontario') + '<br><small>' + T('Elsewhere in Canada: ', 'Ailleurs au Canada : plus que ') + money(T2 - v) + T(' more for free shipping', '') + '</small>' + bar(Math.round(v / T2 * 100)) + '</div>';
    var left = THRESHOLD - v, pct = Math.min(100, Math.round(v / THRESHOLD * 100));
    return '<div class="sa-ship" data-sa-ship>' + T('You are ', 'Plus que ') + '<b>' + money(left) + '</b>' + T(' away from free shipping (QC/ON · $199 elsewhere in Canada)', ' pour la livraison gratuite (QC/ON · 199 $ ailleurs au Canada)') + bar(pct) + '</div>';
  }
  var lastCart = null;
  function updateShipBars(cart) {
    if (cart) lastCart = cart;
    if (!lastCart) return;
    var targets = document.querySelectorAll('#CartDrawer form, .drawer--cart form, cart-drawer form, [data-cart-drawer] form, form.cart, form[action$="/cart"]');
    targets.forEach(function (f) {
      if (f.closest('.sa-calc')) return;
      var html = shipHTML(lastCart); var old = f.querySelector('[data-sa-ship]');
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      if (old && old.textContent === tmp.textContent) return;
      if (old) old.remove(); if (!html) return;
      f.insertAdjacentHTML('afterbegin', html);
    });
  }
  var shipTimer;
  function scheduleShip() { clearTimeout(shipTimer); shipTimer = setTimeout(function () { getCart().then(updateShipBars); }, 350); }

  /* ---------- Sticky add-to-cart (mobile product pages) ---------- */
  function initSticky() {
    if (!/\/products\//.test(location.pathname)) return;
    var form = document.querySelector('form[action*="/cart/add"]:not([data-sa-calc])');
    if (!form) return;
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (!btn) return;
    var title = (document.querySelector('h1') || {}).textContent || '';
    var img = document.querySelector('meta[property="og:image"]');
    var price = document.querySelector('[data-product-price], .product__price, .price-item--regular, .product-single__price');
    var bar = document.createElement('div');
    bar.className = 'sa-sticky';
    bar.innerHTML = (img ? '<img src="' + img.content.replace(/^http:/, 'https:') + '" alt="">' : '') +
      '<div class="sa-sticky__info"><div class="sa-sticky__title">' + title.trim().replace(/</g, '&lt;') + '</div><div class="sa-sticky__price">' + (price ? price.textContent.trim().replace(/\s+/g, ' ') : '') + '</div></div>' +
      '<button type="button" class="sa-btn sa-btn--primary">' + T('Add to cart', 'Ajouter au panier') + '</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function () { btn.click(); });
    new IntersectionObserver(function (e) { bar.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(btn);
  }

  /* ---------- Shop-by-colour quick add ---------- */
  function initColours(scope) {
    (scope || document).querySelectorAll('[data-sa-colour]:not([data-ready])').forEach(function (card) {
      card.setAttribute('data-ready', '');
      var input = card.querySelector('input');
      card.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () { var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10)); input.value = v; });
      });
      var add = card.querySelector('.sa-add');
      if (add) add.addEventListener('click', function () { addItems([{ id: +card.dataset.variant, quantity: Math.max(1, parseInt(input.value, 10) || 1) }], add); });
    });
  }

  /* ---------- Yarn calculator ---------- */
  function initCalc(scope) {
    (scope || document).querySelectorAll('[data-sa-calc]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '');
      var price = +root.dataset.price;
      var count = 0, variant = null;
      var elCount = root.querySelector('[data-count]'), elTotal = root.querySelector('[data-total]'), elFill = root.querySelector('.sa-progress__fill'),
        elTxt = root.querySelector('.sa-progress__txt'), elBtn = root.querySelector('[data-calc-add]'), elName = root.querySelector('[data-colour-name]'), elWord = root.querySelector('[data-skein-word]');
      function render() {
        var total = count * price;
        elCount.textContent = count;
        if (elWord) elWord.textContent = count > 1 ? T('skeins', 'pelotes') : T('skein', 'pelote');
        elTotal.textContent = money(total);
        var left = THRESHOLD - total, pct = Math.min(100, Math.round(total / THRESHOLD * 100));
        elFill.style.width = pct + '%';
        elTxt.innerHTML = left > 0 ? T('Add ', 'Ajoutez ') + '<b>' + Math.ceil(left / price) + '</b>' + T(' more skein(s) for <b>free shipping</b> (QC/ON)', ' pelote(s) pour la <b>livraison gratuite</b> (QC/ON)') : '🎉 <b>' + T('Free shipping included', 'Livraison gratuite incluse') + '</b>';
        elBtn.disabled = !variant || !count;
        elBtn.querySelector('span').textContent = variant ? T('Add ' + count + ' skeins · ', 'Ajouter ' + count + ' pelotes · ') + money(total) : T('Choose a colour', 'Choisissez une couleur');
      }
      root.querySelectorAll('.sa-size input').forEach(function (r) {
        r.addEventListener('change', function () {
          root.querySelectorAll('.sa-size').forEach(function (l) { l.classList.remove('is-active'); });
          r.closest('.sa-size').classList.add('is-active'); count = +r.value; render();
        });
        if (r.checked) { r.closest('.sa-size').classList.add('is-active'); count = +r.value; }
      });
      root.querySelectorAll('.sa-swatch').forEach(function (s) {
        s.addEventListener('click', function () {
          root.querySelectorAll('.sa-swatch').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          s.classList.add('is-active'); s.setAttribute('aria-pressed', 'true'); variant = +s.dataset.variant;
          if (elName) elName.textContent = s.dataset.name; render();
        });
      });
      var plus = root.querySelector('[data-calc-more]'), minus = root.querySelector('[data-calc-less]');
      if (plus) plus.addEventListener('click', function () { count++; render(); });
      if (minus) minus.addEventListener('click', function () { count = Math.max(1, count - 1); render(); });
      elBtn.addEventListener('click', function () { if (variant && count) addItems([{ id: variant, quantity: count }], null); });
      render();
    });
  }

  /* ---------- Newsletter (native customer form, no reload UX) ---------- */
  function initNews(scope) {
    (scope || document).querySelectorAll('form[data-sa-news]:not([data-ready])').forEach(function (f) { f.setAttribute('data-ready', ''); });
  }

  function initAll(scope) { initReveal(scope); initColours(scope); initCalc(scope); initNews(scope); }

  function boot() {
    initAll(document); initSticky(); scheduleShip();
    // Re-inject shipping bar whenever theme re-renders cart
    var mo = new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var t = m[i].target;
        if (t.closest && t.closest('#CartDrawer, .drawer--cart, cart-drawer, [data-cart-drawer], form.cart') && !(m[i].addedNodes[0] && m[i].addedNodes[0].hasAttribute && m[i].addedNodes[0].hasAttribute('data-sa-ship'))) { scheduleShip(); break; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('submit', function (e) { if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) setTimeout(scheduleShip, 900); }, true);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
